jQuery(document).ready(function() {

    $(".control-button--sound").click( function (){
        console.log('control-button--sound click');
        if( $(this).closest('.ss-video').find('video').prop('muted') ) {
            $(this).closest('.ss-video').find('video').prop('muted', false);
        } else {
            $(this).closest('.ss-video').find('video').prop('muted', true);
        }

        if ($(this).hasClass('sound') ) {
            $(this).removeClass('sound');
        } else {
            $(this).addClass('sound');    
        }
        
    });

});

